import { render } from "./DashboardPerformanceOverview.vue?vue&type=template&id=32e680bf&scoped=true"
import script from "./DashboardPerformanceOverview.vue?vue&type=script&lang=js"
export * from "./DashboardPerformanceOverview.vue?vue&type=script&lang=js"

import "./DashboardPerformanceOverview.vue?vue&type=style&index=0&id=32e680bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e680bf"]])

export default __exports__